import { observer } from 'mobx-react';
import ModalForm from './ModalForm';
import ModalSubmitted from './ModalSubmitted';
import { AddLicenseToGroupsStore } from './Store';

interface Props {
  licenseAllocationsStore: AddLicenseToGroupsStore;
}

function Display({ licenseAllocationsStore }: Props) {
  switch (licenseAllocationsStore.state.kind) {
    case 'waiting':
      return <></>;
    case 'loading':
    case 'loading-error':
    case 'ready':
    case 'submitting':
    case 'submitting-error':
      return (
        <ModalForm
          state={licenseAllocationsStore.state}
          licenseAllocationsStore={licenseAllocationsStore}
        />
      );
    case 'submitted':
      return (
        <ModalSubmitted
          state={licenseAllocationsStore.state}
          licenseAllocationsStore={licenseAllocationsStore}
        />
      );
  }
}

export default observer(Display);
